//
//
//
//
//
//
//
//
//

import { store } from "./store"

export default {

  name: 'PanelStoryGroup',
  props: ['story'],

  methods: {
     pass_to_filter() {       
      let a = this.story._mapping_story_attached_projects
      if (a !== undefined) {
        store.resetFilterValues()
        store.updateFilterValues('post_id', a)
        //send message to update the Map
        this.$root.$emit('updateGoogleMap')
      }
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelStoryGroup.vue